
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/sentry.client.config.ts")
            }
          });